import React, { FC } from 'react';
import { useIsMobile, useIsTablet } from '@sravni/react-utils';
import { FORM_FIELDS_PHONES, QUERY_PARTNER_KEYS, FORM_FIELDS, PAGE } from '../../../../constants';
import { getCommonServerSideProps, collectQueryParams } from '../../../../helpers/serverside.props';
import { SelectionApp } from '../../../../types/app';
import { PURPOSE_SOURCE_VALUES } from '../../../../constants/sources';
import { pick, removeUndefined, formatPhonesImmutable, getGlobalRegionFormFields } from '../../../../helpers';
import { getGlobalRegionForForm } from '../../../../server/helpers';
import LandingCreditCard from '../../../../components/landing.credit.card';
import { useUser } from '../../../../store/reducers/user';
import { getLocationByRoute } from '../../../../services/location/location.service';
import { useContentWindowIframeResizer } from '../../../../components/hooks/iframe.resizer';

interface Props {
    formData: FE.FormData;
    userId?: string;
    authImport?: boolean;
    pixel?: string | null;
    cookies: Record<string, string>;
}

const CardsWhitelable: FC<Props> = (props) => {
    useContentWindowIframeResizer({ setStaticIframeScreenSize: true });
    const { pixel, formData } = props;
    const account = useUser();
    const userId = account?.sub;
    const isTablet = useIsTablet();
    const isMobile = useIsMobile();

    return (
        <>
            {pixel && (
                <img
                    style={{
                        display: 'block',
                        position: 'absolute',
                        opacity: '0',
                        left: '0',
                        top: '0',
                    }}
                    src={pixel}
                    alt=""
                />
            )}
            <LandingCreditCard
                formData={formData}
                userId={userId}
                isTablet={isTablet}
                isMobile={isMobile}
                withSilentAuth
                cookies={props.cookies}
            />
        </>
    );
};

const getShowPixel = (ctx: SelectionApp.PageContext) => {
    const options = pick(ctx.query, QUERY_PARTNER_KEYS);
    if (Object.keys(options).length === 0) {
        return null;
    }
    return (
        'https://go.sravni.ru/aff_i?' +
        Object.entries(options)
            .map(([key, value]) => `${key}=${String(value)}`)
            .join('&')
    );
};

export const getServerSideProps = async (ctx: SelectionApp.PageContext): Promise<{ props: Props }> => {
    const [{ props: commonPageProps }, locationsByRoute] = await Promise.all([
        getCommonServerSideProps(PAGE.CARDS_WHITELABEL)(ctx),
        // Проверка что location не string[]
        typeof location === 'string' ? getLocationByRoute(location) : Promise.resolve(null),
    ]);
    const { __WHITELABEL_UID__: userId, __AUTH_IMPORT__: authImport } = ctx.req;

    const currentUserLoggedIn =
        commonPageProps.initialState.user.loggedIn &&
        userId &&
        commonPageProps.initialState.user.account?.sub === userId;

    const queryData = collectQueryParams(ctx, commonPageProps.initialState.user.loggedIn && !currentUserLoggedIn);

    const globalRegion =
        Array.isArray(locationsByRoute) && locationsByRoute.length > 0
            ? locationsByRoute[0]
            : await getGlobalRegionForForm({
                  currentLocation: commonPageProps.initialState.locations.currentLocation,
                  useCurrentLocation: commonPageProps.isLocationManuallySet,
              });

    const formData = {
        [FORM_FIELDS.MONTHLY_SALARY]: 50_000,
        [FORM_FIELDS.PURPOSE]: PURPOSE_SOURCE_VALUES.MONEY,
        ...getGlobalRegionFormFields(globalRegion),
        ...queryData,
    };

    return removeUndefined({
        props: {
            ...commonPageProps,
            initialState: {
                ...commonPageProps.initialState,
                locations: {
                    ...commonPageProps.initialState.locations,
                    currentLocation: globalRegion || commonPageProps.initialState.locations.currentLocation,
                },
            },
            userId,
            formData: formatPhonesImmutable(formData, FORM_FIELDS_PHONES),
            authImport: Boolean(userId && authImport),
            pixel: getShowPixel(ctx),
        },
    });
};

export default CardsWhitelable;
